










import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({
  name: 'form-title'
})
export default class extends Vue {
  @Prop({ required: true }) private title!: string // 小标题
  @Prop({ required: false }) private subTitle!: string // 小标题
  @Prop({ default: false }) private require!: boolean // 是否展示必传标志
  @Prop({ default: '' }) private myStyle!:string // 自定义样式
  get required() {
    return this.require
  }
}
